export default "__VITE_ASSET__BunbywKY__"